//addStudent ve AddClass işlemier bu componente yapılır
import { useState, useEffect } from "react";
import { useFormik } from "formik";
import { classYup } from "../Schema/class";
import Input from "../CommanComponents/Input";
import api from "../utils/api";
import * as yup from "yup";

import {
  Users,
  User,
  Save,
  X,
  AlertCircle,
  Search,
  Check,
  MapPin,
  Filter,
  Plus,
} from "lucide-react";
import cities from "../constants/turkey_cities_full.json";
import { useDispatch } from "react-redux";
import { activeComponentValue } from "../redux/slice/ActiveComponentSlice";
import { useNavigate } from "react-router-dom";

function AddClass({
  capacity,
  classTitle,
  classDescription,
  classId,
  classType,
}) {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [students, setStudents] = useState([]);
  const [filteredStudents, setFilteredStudents] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedCity, setSelectedCity] = useState("");
  const [selectedDistrict, setSelectedDistrict] = useState("");
  const [districts, setDistricts] = useState([]);
  const [isLoadingStudents, setIsLoadingStudents] = useState(false);
  //class type belirlemek için kullanıla
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const teacherId = JSON.parse(localStorage.getItem("postUser"));
  const teacher_id = teacherId?._id;
  const classTypes = [
    { name: "class 2", value: "class 2" },
    { name: "class 3", value: "class 3" },
    { name: "class 4", value: "class 4" },
  ];
  // Öğrenci arama fonksiyonu
  useEffect(() => {
    if (!searchTerm.trim()) {
      setFilteredStudents(students);
      return;
    }

    const filtered = students.filter(
      (student) =>
        student.username?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        student.email?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        (student.firstName &&
          student.firstName.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (student.lastName &&
          student.lastName.toLowerCase().includes(searchTerm.toLowerCase())),
    );
    setFilteredStudents(filtered);
  }, [searchTerm, students]);

  // Öğrenci listesini getir
  const handleLocationSelect = async () => {
    if (!selectedCity || !selectedDistrict) {
      alert("Lütfen şehir ve ilçe seçiniz!");
      return;
    }
    setIsLoadingStudents(true);
    try {
      const res = await api.get("getAllStudent", {
        params: {
          role: "student",
          city: selectedCity,
          district: selectedDistrict,
          classType: formik.values.classType || classType,
        },
      });
      if (res.status === 200) {
        setStudents(res.data.studentArrayresult || []);
        setFilteredStudents(res.data.studentArrayresult || []);
      }
    } catch (error) {
      console.error("Öğrenci listesi çekmede hata oluştu", error);
      alert("Öğrenci listesi yüklenirken hata oluştu!");
    } finally {
      setIsLoadingStudents(false);
    }
  };
  const submit = async (values) => {
    // console.log("çalıtı");
    // console.log(values, "formokten gelen value değerleri");
    setIsSubmitting(true);
    try {
      // YENİ SINIF OLUŞTURMA - classId yoksa veya boşsa
      if (!classId) {
        const classData = {
          className: values.className || classTitle,
          teacherId: teacher_id,
          description: values.description || classDescription,
          maxStudents: values.maxStudents || capacity,
          students: values.selectedStudents,
          classType: values.classType,
        };
        const response = await api.post("create-class", classData);
        if (response.status === 201) {
          alert("Sınıf başarıyla oluşturuldu!");
          formik.resetForm();
          setStudents([]);
          setFilteredStudents([]);
          setSearchTerm("");
          setSelectedCity("");
          setSelectedDistrict("");
          setDistricts([]);
          dispatch(activeComponentValue(3));
          navigate("/routePage");
        }
      }
      // MEVCUT SINIFA ÖĞRENCİ EKLEME - classId varsa
      else {
        const updateStudentList = {
          classId: classId,
          students: values.selectedStudents,
        };

        const response = await api.put("addStudentClass", updateStudentList);

        if (response.status === 200) {
          // console.log(response.data, "yeni sınıf oluşturma");
          alert("Öğrenciler başarıyla sınıfa eklendi!");

          formik.setFieldValue("selectedStudents", []);
          setStudents([]);
          setFilteredStudents([]);
          setSearchTerm("");
          dispatch(activeComponentValue(3));
          navigate("/routePage");
        }
      }
    } catch (error) {
      console.error("İşlem sırasında hata oluştu:", error);
      alert(error.response?.data?.message || "İşlem sırasında hata oluştu!");
    } finally {
      setIsSubmitting(false);
    }
  };
  const dynamicSchema = !classId
    ? classYup
    : yup.object().shape({
        // Öğrenci ekleme modunda sadece seçilen öğrencileri kontrol et
        selectedStudents: yup
          .array()
          .min(1, "Lütfen en az bir öğrenci seçin")
          .max(capacity || 50, "Sınıf kapasitesi aşılamaz"),
      });
  const formik = useFormik({
    initialValues: {
      className: classTitle || "",
      teacherId: teacher_id,
      description: classDescription || "",
      maxStudents: capacity || 30,
      selectedStudents: [],
      classType: classType || "",
    },
    onSubmit: submit,
    validationSchema: dynamicSchema, // classYup yerine oluşturduğumuz dinamik şemayı bağladık
  });

  // Öğrenci seçme/çıkarma fonksiyonu
  const toggleStudentSelection = (studentId) => {
    const currentSelected = formik.values.selectedStudents;
    const isSelected = currentSelected.includes(studentId);

    if (isSelected) {
      formik.setFieldValue(
        "selectedStudents",
        currentSelected.filter((id) => id !== studentId),
      );
    } else {
      if (currentSelected.length >= formik.values.maxStudents) {
        alert(`En fazla ${formik.values.maxStudents} öğrenci seçebilirsiniz!`);
        return;
      }
      formik.setFieldValue("selectedStudents", [...currentSelected, studentId]);
    }
  };

  // Seçilen öğrenci bilgisini getir
  const getSelectedStudentInfo = (studentId) => {
    return students.find((student) => student._id === studentId);
  };

  // Şehir ve ilçe durumu
  const handleCityChange = (e) => {
    const cityName = e.target.value;
    setSelectedCity(cityName);
    setSelectedDistrict("");

    const city = cities.find((c) => c.il === cityName);
    setDistricts(city ? city.ilceler : []);
  };

  const handleDistrictChange = (e) => {
    setSelectedDistrict(e.target.value);
  };
  return (
    <form onSubmit={formik.handleSubmit}>
      {/* Temel Bilgiler */}
      <div className="space-y-6 flex flex-col">
        <h2 className="text-xl font-semibold text-center text-gray-600 ">
          {capacity === null ? "Yeni Sınıf Oluştur" : classTitle}
        </h2>
        <div
          className={
            capacity === null || classTitle === null ? "block" : "hidden"
          }
        >
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <Input
              title="Sınıf Adı"
              type="text"
              id="className"
              name="className"
              value={formik.values.className}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              placeholder="Örn: A1 Beginner Class"
              touched={formik.touched.className}
              errors={formik.errors.className}
            />

            <Input
              title="Maksimum Öğrenci Sayısı"
              type="number"
              id="maxStudents"
              name="maxStudents"
              value={formik.values.maxStudents}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              placeholder="30"
              min="1"
              max="50"
              touched={formik.touched.maxStudents}
              errors={formik.errors.maxStudents}
            />
          </div>
          {/* Sınıf Tipi Seçimi (Radio Buttons) */}
          <div className="col-span-1 md:col-span-2 space-y-3">
            <label className="block text-sm font-medium text-gray-700">
              Sınıf Seviyesi / Tipi
            </label>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
              {classTypes.map((type) => {
                const isSelected = formik.values.classType === type.value;
                return (
                  <label
                    key={type.value}
                    className={`
            relative flex cursor-pointer rounded-xl border p-4 shadow-sm focus:outline-none
            transition-all duration-200 items-center justify-between
            ${
              isSelected
                ? "border-purple-500 ring-2 ring-purple-200 bg-purple-50"
                : "border-gray-200 bg-white hover:bg-gray-50"
            }
          `}
                  >
                    <input
                      type="radio"
                      name="classType"
                      value={type.value}
                      checked={isSelected}
                      onChange={() =>
                        formik.setFieldValue("classType", type.value)
                      }
                      className="sr-only"
                    />
                    <div className="flex items-center">
                      <span
                        className={`text-sm font-semibold ${isSelected ? "text-purple-900" : "text-gray-900"}`}
                      >
                        {type.name.toUpperCase()}
                      </span>
                    </div>

                    {isSelected ? (
                      <div className="bg-purple-500 rounded-full p-1">
                        <Check className="w-3 h-3 text-white" />
                      </div>
                    ) : (
                      <div className="w-5 h-5 border-2 border-gray-300 rounded-full" />
                    )}
                  </label>
                );
              })}
            </div>
            {/* Hata Mesajı */}
            {formik.touched.classType && formik.errors.classType && (
              <div className="text-red-500 text-xs mt-1 flex items-center">
                <AlertCircle className="w-3 h-3 mr-1" />{" "}
                {formik.errors.classType}
              </div>
            )}
          </div>

          <Input
            title="Açıklama"
            type="textarea"
            id="description"
            name="description"
            value={formik.values.description}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            placeholder="Sınıf hakkında kısa açıklama..."
            touched={formik.touched.description}
            errors={formik.errors.description}
          />
        </div>
      </div>

      {/* Lokasyon Seçimi */}
      <div className="space-y-6">
        <h2
          className="text-lg font-semibold text-gray-800 border-b
               border-gray-200 pb-3 flex items-center"
        >
          <MapPin className="w-6 h-6 mr-2 text-yellow-400" />
          Öğrenci Lokasyonu
        </h2>

        <div className="bg-gray-50 p-6 rounded-xl">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
            <div className="space-y-2">
              <label className="block text-sm font-medium text-gray-700">
                İl Seçimi
              </label>
              <select
                className="w-full border border-gray-300 rounded-lg p-3 
                      focus:ring-2 focus:ring-purple-500 focus:border-transparent transition-all outline-none"
                value={selectedCity}
                onChange={handleCityChange}
              >
                <option value="">İl Seçiniz</option>
                {cities.map((city) => (
                  <option key={city.il} value={city.il}>
                    {city.il}
                  </option>
                ))}
              </select>
            </div>

            <div className="space-y-2">
              <label className="block text-sm font-medium text-gray-700">
                İlçe Seçimi
              </label>
              <select
                className="w-full border border-gray-300 rounded-lg p-3 focus:ring-2
                       focus:ring-purple-500 focus:border-transparent transition-all
                        disabled:bg-gray-100 outline-none"
                value={selectedDistrict}
                onChange={handleDistrictChange}
                disabled={!selectedCity}
              >
                <option value="">
                  {selectedCity ? "İlçe Seçiniz" : "Önce İl Seçiniz"}
                </option>
                {districts.map((district) => (
                  <option key={district} value={district}>
                    {district}
                  </option>
                ))}
              </select>
            </div>

            <div className="flex items-end">
              <button
                type="button"
                onClick={handleLocationSelect}
                disabled={
                  !selectedCity || !selectedDistrict || isLoadingStudents
                }
                className="w-full bg-purple-500 text-white rounded-lg px-4 py-3
                       hover:bg-purple-700 transition-all disabled:bg-gray-300 disabled:cursor-not-allowed 
                       flex items-center justify-center space-x-2"
              >
                {isLoadingStudents ? (
                  <>
                    <div
                      className="w-4 h-4 border-2 border-white border-t-transparent 
                          rounded-full animate-spin"
                    ></div>
                    <span>Yükleniyor...</span>
                  </>
                ) : (
                  <>
                    <Filter className="w-4 h-4" />
                    <span>Öğrenci Listele</span>
                  </>
                )}
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Öğrenci Seçimi Bölümü */}
      {students.length > 0 && (
        <div className="space-y-6">
          <div className="flex items-center justify-between">
            <h2 className="text-2xl font-semibold text-gray-800 flex items-center">
              <Users className="w-6 h-6 mr-2 text-yellow-400" />
              Öğrenci Seçimi
            </h2>
            <div
              className="bg-blue-100 text-blue-800 
                  px-4 py-2 rounded-full text-sm font-medium "
            >
              {formik.values.selectedStudents.length}/
              {formik.values.maxStudents} seçildi
            </div>
          </div>

          {/* Arama Kutusu */}
          <div className="relative ">
            <Search
              className="w-5 h-5 absolute left-3 top-1/2 
                  transform -translate-y-1/2 text-gray-400"
            />
            <input
              type="text"
              placeholder="Öğrenci ara (ad, soyad, email...)..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-xl focus:ring-2
                     focus:ring-purple-500 focus:border-transparent transition-all outline-none"
            />
          </div>

          {/* Seçilen Öğrenciler Önizleme */}
          {formik.values.selectedStudents.length > 0 && (
            <div className="bg-gray-100 p-6 rounded-xl border border-blue-200">
              <h4 className="text-sm font-semibold text-blue-800 mb-3 flex items-center">
                <Check className="w-4 h-4 mr-2" />
                Seçilen Öğrenciler ({formik.values.selectedStudents.length}
                ):
              </h4>
              <div className="flex flex-wrap gap-2">
                {formik.values.selectedStudents.map((studentId) => {
                  const student = getSelectedStudentInfo(studentId);
                  return (
                    <span
                      key={studentId}
                      className="inline-flex items-center px-4 py-2 bg-white 
                             text-sm rounded-full border border-blue-200 shadow-sm"
                    >
                      <User className="w-3 h-3 mr-2 text-yellow-400" />
                      {student?.firstName || student?.username}{" "}
                      {student?.lastName || ""}
                      <button
                        type="button"
                        onClick={() => toggleStudentSelection(studentId)}
                        className="ml-2 text-blue-600 hover:text-red-600 transition-colors"
                      >
                        <X className="w-4 h-4" />
                      </button>
                    </span>
                  );
                })}
              </div>
            </div>
          )}

          {/* Öğrenci Listesi */}
          <div className="border border-gray-200 rounded-xl overflow-hidden">
            <div className="max-h-96 overflow-y-auto">
              {filteredStudents.length === 0 ? (
                <div className="p-8 text-center text-gray-500">
                  <Users className="w-12 h-12 mx-auto mb-4 text-gray-300" />
                  <p className="text-lg font-medium mb-2">Öğrenci bulunamadı</p>
                  <p className="text-sm">
                    Farklı arama kriterleri deneyebilirsiniz
                  </p>
                </div>
              ) : (
                <div className="divide-y divide-gray-100">
                  {filteredStudents.map((student) => {
                    const isSelected = formik.values.selectedStudents.includes(
                      student._id,
                    );
                    const isMaxReached =
                      formik.values.selectedStudents.length >=
                      formik.values.maxStudents;

                    return (
                      <div
                        key={student._id}
                        className={`p-4 hover:bg-gray-50 transition-all cursor-pointer ${
                          isSelected
                            ? "bg-gradient-to-r from-blue-50 to-indigo-50 border-l-4 border-purple-500"
                            : ""
                        } ${!isSelected && isMaxReached ? "opacity-50" : ""}`}
                        onClick={() =>
                          !(!isSelected && isMaxReached) &&
                          toggleStudentSelection(student._id)
                        }
                      >
                        <div className="flex items-center justify-between">
                          <div className="flex items-center space-x-4">
                            <div
                              className={`w-12 h-12 rounded-full flex 
                                      items-center justify-center transition-all bg-yellow-400 ${
                                        isSelected
                                          ? "bg-blue-500 text-white shadow-lg"
                                          : "bg-gray-100 text-gray-600"
                                      }`}
                            >
                              {isSelected ? (
                                <Check className="w-5 h-5" />
                              ) : (
                                <User className="w-5 h-5 text-white" />
                              )}
                            </div>

                            <div className="flex-1">
                              <h4 className="font-semibold text-gray-900 text-lg">
                                {student.firstName || student.username}{" "}
                                {student.lastName || ""}
                              </h4>
                              <div
                                className="flex items-center space-x-4
                                     text-sm text-gray-500 mt-1"
                              >
                                <span>@{student.username}</span>
                                <span>•</span>
                                <span>{student.email}</span>
                              </div>
                              {student.englishLevel && (
                                <div className="mt-2">
                                  <span
                                    className="inline-block px-3 py-1 text-xs font-medium
                                         bg-green-100 text-green-800 rounded-full"
                                  >
                                    Seviye: {student.englishLevel}
                                  </span>
                                </div>
                              )}
                            </div>
                          </div>

                          {!isSelected && isMaxReached && (
                            <span
                              className="text-xs text-red-500 bg-red-50 px-3 
                                  py-1 rounded-full font-medium"
                            >
                              Limit doldu
                            </span>
                          )}
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          </div>

          {/* Validasyon Hatası */}
          {formik.touched.selectedStudents &&
            formik.errors.selectedStudents && (
              <div className="flex items-center text-red-600 text-sm bg-red-50 p-3 rounded-lg">
                <AlertCircle className="w-4 h-4 mr-2" />
                {formik.errors.selectedStudents}
              </div>
            )}
        </div>
      )}

      {/* Submit Button */}
      <div className="pt-6 border-t border-gray-200">
        <button
          className={`w-full h-16 rounded-2xl text-xl font-bold transition-all duration-300 
                  flex items-center justify-center space-x-3 ${
                    isSubmitting
                      ? "bg-gray-400 cursor-not-allowed"
                      : "bg-purple-500 text-white shadow-lg hover:shadow-xl transform "
                  }`}
          type="submit"
          disabled={isSubmitting}
        >
          {isSubmitting ? (
            <>
              <div
                className="w-6 h-6 border-2 border-white border-t-transparent
                     rounded-full animate-spin"
              ></div>
              <span>Kaydediliyor...</span>
            </>
          ) : (
            <div>
              <div
                className={
                  classDescription === null || capacity === null
                    ? "flex justify-center items-center gap-2"
                    : "hidden"
                }
              >
                <Save className="w-6 h-6" />
                <span>Create Class</span>
              </div>
              <div
                className={
                  classDescription === null || capacity === null
                    ? "hidden"
                    : "flex justify-center items-center gap-2"
                }
              >
                <Plus className="w-6 h-6" />
                <span>Add Student</span>
              </div>
            </div>
          )}
        </button>
      </div>
    </form>
  );
}

export default AddClass;
